import React from 'react'
import CollectionContainer from '../collection-container'
import './item.css'

const Item = ({ 
  setElementScroll,
  onSetScroll, 
  onSaveScroll, 
  pageName, 
  pageExitComplete,
  st,
  match }) => {

  const active = (match && match.isExact)
  const id = active ? match.params.collectionId : null

  return (
    <div className="item">
      <CollectionContainer
        setElementScroll={setElementScroll}
        onSaveScroll={onSaveScroll}
        onSetScroll={onSetScroll}
        pageName={pageName}
        pageExitComplete={pageExitComplete}
        match={match}
        active={active}
        st={st}
        id={id} />
    </div>
  )
}

export default Item



// WEBPACK FOOTER //
// ./src/components/item-page/item.js